import { z } from "zod";

import { NodeRole } from "@skilitics/nautilus-core/schemas";

import { ownerOrCreatorSchema } from "../designerNode/index.ts";
import { nodeConfigSchema } from "../shared/index.ts";
import { slotSchema } from "./slotSchemas.ts";
import { triggerDesignsStateSchema } from "./triggerDesignsStateSchema.ts";

const designSchema = z.object({
  typeId: z.string(),
  config: nodeConfigSchema, // multilingualNodeConfigSchema,
  owner: ownerOrCreatorSchema.optional(),
  creator: ownerOrCreatorSchema.optional(),
  role: NodeRole.optional(),
});

const designsByIdSchema = z.record(designSchema);

const slotsByParentIdSchema = z.record(z.record(z.union([slotSchema, z.array(slotSchema)])));

const parentIdByChildIdSchema = z.record(z.number());

export const nodeDesignsStateSchema = z.object({
  nextId: z.number(),
  designsById: designsByIdSchema,
  parentIdByChildId: parentIdByChildIdSchema,
  slotsByParentId: slotsByParentIdSchema,
  versionByTypeId: z.record(z.string(), z.string()),
  triggerDesigns: triggerDesignsStateSchema,
  upstreamTemplateIdById: z.record(z.number()),
});

export const simplifiedNodeDesignsStateSchema = nodeDesignsStateSchema.omit({ designsById: true }).extend({
  designsById: z.record(designSchema.omit({ config: true }).extend({ config: z.record(z.string(), z.unknown()) })),
});
